import { Component, h, Host, Prop } from '@stencil/core'
import { toMoney } from '@rdss/core'
import { VariantSwitchItem } from './types'

@Component({
    tag: 'zr-variant-switch-item',
    styleUrl: './zr-variant-switch-item.scss',
    scoped: true,
})
/**
 * Variant.
 */
export class ZrVariantSwitchItem {
    /**
     * This is a variant switch item.
     */
    @Prop() variant: VariantSwitchItem

    /**
     * This marks the product as the best value for money offer.
     */
    @Prop() hasLowestPricePerUnit: boolean

    /**
     * Locale used for currencies.
     */
    @Prop() locale: string

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render() {
        return (
            <Host>
                {this.variant?.price &&
                    <div class={{
                        'zr-variant-switch-item-inner': true,
                        selected: this.variant.selected,
                        disabled: !this.variant.isAvailable,
                    }}
                    >
                        <div class="header">
                            <div class="text">{this.variant.text}</div>
                            {this.hasLowestPricePerUnit &&
                                <div class="zr-variant-switch-item__icon" title={this.variant.title}></div>
                            }
                        </div>

                        <div class="body">
                            {this.variant.unit.unit &&
                                <div class="base">{toMoney(this.variant.price.pricePerUnit,
                                    this.variant.price.currency,
                                    this.locale)}&nbsp;/&nbsp;
                                {this.variant.unit.referenceUnit} {this.variant.unit.unit}
                                </div>
                            }
                            <div class="prize">
                                {toMoney(this.variant.price.gross, this.variant.price.currency, this.locale)}
                            </div>
                        </div>
                    </div>
                }
            </Host>
        )
    }
}
